import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  useShowController,
  Pagination,
  FunctionField
} from 'react-admin';
import { Box, Typography, Chip, Toolbar } from '@mui/material';
import EmptyState from '../EmptyState';
import useStyles from './styles';
import { formatDateTime } from '../../utils/timeFormat';

// Component to display notification read status
const ReadStatus = ({ record }) => {
  const userNotification = record.receivers?.[0]?.LingoUserNotification;
  const isRead = !!userNotification?.readAt;
  
  return (
    <Chip
      label={isRead ? 'Уншсан' : 'Уншаагүй'}
      size="small"
      color={isRead ? 'primary' : 'default'}
    />
  );
};

// Custom actions to show FilterButton
const ListActions = props => {
  const { filters, displayedFilters, filterValues, showFilter, resource } = props;
  return (
    <Toolbar>
      {filters && React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    </Toolbar>
  );
};

// Component to display notification type as colored chip
const NotificationTypeChip = ({ record }) => {
  const type = Array.isArray(record.channels) ? record.channels.join(', ') : (record.type || '');
  const color = 'default';
  return <Chip label={type} size="small" color={color} />;
};


// Panel component for expanded row to show full message
const NotificationMessagePanel = ({ record }) => (
  <Box p={2}>
    <Typography variant="body2" component="div">
      <strong>Мессеж:</strong>
    </Typography>
    <Typography variant="body2" color="textSecondary" style={{ whiteSpace: 'pre-wrap' }}>
      {record.message}
    </Typography>
  </Box>
);

const NotificationsTab = props => {
  const { record, basePath } = useShowController(props);
  const classes = useStyles();
  
  if (!record) return null;

  return (
    <Box>
      <List
        component="div"
        resource="userNotifications"
        basePath={basePath}
        filter={{ userId: record.id }}
        sort={{ field: 'createdAt', order: 'DESC' }}
        bulkActionButtons={false}
        perPage={25}
        pagination={<Pagination />}
        exporter={false}
        actions={<ListActions />}
        empty={<EmptyState message="Энэ хэрэглэгчид мэдэгдэл илгээгдээгүй байна" />}
      >
        <Datagrid 
          className={classes.notificationTable}
          rowClick="expand"
          expand={<NotificationMessagePanel />}
        >
          <TextField source="id" label="ID" />
          <FunctionField 
            label="Төрөл" 
            render={record => <NotificationTypeChip record={record} />} 
          />
          <FunctionField 
            label="Мессеж" 
            render={record => {
              const message = record.message || '';
              const truncated = message.length > 50 ? 
                message.substring(0, 50) + '...' : 
                message;
              return (
                <Typography 
                  variant="body2" 
                  style={{ 
                    cursor: 'pointer',
                    maxWidth: '200px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                  title={message}
                >
                  {truncated}
                </Typography>
              );
            }} 
          />
          <TextField source="contentType" label="Агуулгын төрөл" />
          <FunctionField 
            label="Статус" 
            render={record => <ReadStatus record={record} />} 
          />
          <FunctionField 
            label="Илгээсэн огноо" 
            render={record => formatDateTime(record.createdAt)} 
            className={classes.dateCell}
          />
          <FunctionField 
            label="Хүлээн авсан огноо" 
            render={record => {
              const readAt = record.receivers?.[0]?.LingoUserNotification?.readAt;
              return readAt ? formatDateTime(readAt) : '-';
            }} 
          />
        </Datagrid>
      </List>
    </Box>
  );
};

export default NotificationsTab; 